import styled from '@emotion/styled';
import { ReactNode } from 'react';

export type StatusTone = 'success' | 'warning' | 'danger' | 'neutral';

const Pill = styled.span<{ tone: StatusTone }>`
  --pill-color: ${({ tone }) => STATUS_TONES[tone].color};
  --pill-bg: ${({ tone }) => STATUS_TONES[tone].background};
  --pill-border: ${({ tone }) => STATUS_TONES[tone].border};

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: fit-content;
  min-height: 24px;
  border: 1px solid var(--pill-border);
  border-radius: 999px;
  padding: 4px 10px;
  background: var(--pill-bg);
  color: var(--pill-color);
  font-family: Poppins-B;
  font-size: 11px;
  line-height: 1;
  white-space: nowrap;
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
  box-shadow: 0 0 0 3px color-mix(in srgb, currentColor 16%, transparent);
`;

const STATUS_TONES: Record<
  StatusTone,
  { color: string; background: string; border: string }
> = {
  success: {
    color: '#008f4f',
    background: 'rgba(0, 143, 79, 0.1)',
    border: 'rgba(0, 143, 79, 0.28)',
  },
  warning: {
    color: 'var(--mt-warning)',
    background: 'rgba(255, 176, 0, 0.1)',
    border: 'rgba(255, 176, 0, 0.32)',
  },
  danger: {
    color: '#d92d20',
    background: 'rgba(217, 45, 32, 0.1)',
    border: 'rgba(217, 45, 32, 0.28)',
  },
  neutral: {
    color: 'var(--mt-muted)',
    background: 'var(--mt-surface)',
    border: 'var(--mt-border)',
  },
};

export const StatusPill = ({
  children,
  tone = 'neutral',
  dot = true,
}: {
  children: ReactNode;
  tone?: StatusTone;
  dot?: boolean;
}) => (
  <Pill tone={tone}>
    {dot && <Dot />}
    {children}
  </Pill>
);
